export const SCHEDULE_WRITE_CONTRACT = 2 as const;

export const CLIENT_OUTDATED_MESSAGE = 'The app was updated. Please refresh the page (Ctrl+R) and try again.';
export const SERVER_OUTDATED_MESSAGE = 'The server is being updated. Please try again in a minute.';
